module.exports = __webpack_public_path__ + "ccf015ebd54f0267bf3fe2faec4d92f7.svg";